import { FontStyle, FontWeight, getFontMixin, loadFontFaces } from '@genesislcap/foundation-utils';
export const robotoFontFaces = `
  @import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap')
`;
export const loadRobotoFontFaces = () => {
    loadFontFaces(robotoFontFaces, 'roboto-font-faces');
};
export const robotoFontFamily = 'Roboto, "Segoe UI", Arial, Helvetica, sans-serif';
export const mixinRobotoFont = (style = FontStyle.Normal, weight = FontWeight.Regular) => getFontMixin(robotoFontFamily, style, weight);
